import React, { useState, useEffect, useRef, useCallback } from "react";
import SharesDataService from "../services/SharesService";
import { Link, useParams, useNavigate } from 'react-router-dom';
import TransactionTable from "../../components/TransactionTable";
//import { push } from 'react-router-dom';

const SharesList = (props) => {
  const [shares, setShares] = useState([]);
  const sharesRef = useRef();
  sharesRef.current = shares;

  let { owner } = useParams();

  const retrieveShares = useCallback((ownerParam) => {
    const target = ownerParam ?? owner;
    SharesDataService.getAll(target)
      .then((response) => {
        console.debug("SharesList.getAll response:", response);
        // normalize common backend shapes
        const payload = response?.data ?? response;
        const rows = payload?.data ?? payload?.shares ?? payload?.savings ?? payload;
        setShares(Array.isArray(rows) ? rows : (rows ? [rows] : []));
      })
      .catch((e) => {
        console.error("SharesList.retrieveShares error:", e?.response?.status, e?.response?.data || e?.message || e);
        setShares([]);
      });
  }, [owner]);

  const navigate = useNavigate();
  useEffect(() => {
    retrieveShares();
  }, [retrieveShares]);

  const deleteShares = useCallback((rowIndex) => {
    const id = sharesRef.current[rowIndex].id || sharesRef.current[rowIndex]._id;
    SharesDataService.remove(id)
      .then(() => {
        if (props?.history?.push) props.history.push("dashboard/shares");
        const newShares = [...sharesRef.current];
        newShares.splice(rowIndex, 1);
        setShares(newShares);
      })
      .catch((e) => {
        console.error("deleteShares error:", e?.response?.status || e?.message || e);
      });
  }, [props.history]);

  // wrappers for TransactionTable (accept row objects)
  const handleView = useCallback((row) => {
    const id = row.id || row._id;
    if (id && props?.history?.push) props.history.push(`/dashboard/shares/${id}`);
  }, [props.history]);

  const handleEdit = useCallback((row) => {
    const id = row.id || row._id;
    if (id && props?.history?.push) props.history.push(`/dashboard/shares/edit/${id}`);
  }, [props.history]);

  const handleDeleteRow = useCallback((row) => {
    const idx = sharesRef.current.findIndex(item => (item.id || item._id) === (row.id || row._id));
    if (idx >= 0) deleteShares(idx);
  }, [deleteShares]);

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <TransactionTable
          transactions={shares}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDeleteRow}
          initialPageSize={10}
          showBack={true}
          onBack={() => navigate(-1)}
        />
      </div>

      <div className="col-md-8">
        <Link to={`/dashboard/shares/add/${owner}`}>
           <button className="btn btn-sm btn-danger">Add Shares Transaction</button>
        </Link>
      </div>
    </div>
  );
};

export default SharesList;
